import React from "react";
import { getImage } from "../../helpers";
import url from "../config/Config";
import { formatHumansBs } from "../../helpers/formatHuman";
import { useState } from "react";
import { agregarCarrito } from "../../helpers/carrito";

const ProductosListItem = ({ producto, listaDetalleProducto, setProduct }) => {

    const [agregadoCarrito, setAgregadoCarrito] = useState(false);
    const { nombre, imagen, stock, decuento, precio, idproducto } = producto;

    const addCart = (producto) => {
        setAgregadoCarrito(true);
        agregarCarrito(producto);
        setTimeout(() => {
            setAgregadoCarrito(false);
        }, 1000);
    }

    return (
        <div className="bg-white py-3 px-1 rounded-xl shadow-md border  hover:scale-105 transition-all duration-300">
            <div
                className="relative group px-3"
            >
                <img
                    src={getImage(imagen)}
                    alt="Propiedad imagen"
                    className="object-cover h-40 w-full aspect-square"
                />
                <span className="absolute top-3 right-6 opacity-0 group-hover:opacity-100 transition duration-500 bg-white px-2 py-1 rounded-sm shadow-xl">
                    <i className="fas fa-heart hover:text-red-500 cursor-pointer text-gray-500"></i>
                </span>
            </div>
            <div className="px-2 space-y-2">
                <p className="text-gray-400 text-center uppercase font-semibold">
                    1ERTY6
                </p>
                <div className="flex flex-col mb-2">
                    <p className="text-truncate text-center hover:underline hover:cursor-pointer" onClick={() => {
                        listaDetalleProducto(idproducto);
                        setProduct(producto);
                    }}>
                        {url.capitalizeWords(nombre)}
                    </p>
                    <p className="font-bold text-center text-lg">
                        {formatHumansBs(
                            (precio - (decuento / 100) * precio).toFixed(2)
                        )}
                    </p>
                    <p className="text-gray-500 font-semibold text-xs text-center">
                        En 3 cuotas:{" "}
                        <span className="font-bold text-sm text-gray-600">
                            {formatHumansBs(precio / 3)}
                        </span>
                    </p>
                </div>
                <button
                    style={{
                        padding: "0",
                        margin: "0",
                        height: "auto",
                    }}
                    className="rounded-lg font-semibold bg-tertiary-personalize text-white flex items-center justify-center w-full py-2 px-3 text-center gap-1"
                    onClick={() => addCart(producto)}
                    disabled={agregadoCarrito}
                >
                    Agregar                    
                </button>
            </div>
        </div>
    );
};

export default ProductosListItem;
